<template>
  <div>
    <!-- 贴标配送单列表界面 -->
    <baseBreadcrumb :page="$t('message.labelDistributionSingleListInterface')" :menu="$t('message.porder')" />
    <div class="body">
      <!-- 筛选 -->
      <div class="search">
        <div class="tabs">
          <el-tabs v-model="datas.fba_status_filter" type="card" @tab-click="search">
            <!-- 全部 -->
            <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
            <!-- 待分配 -->
            <el-tab-pane :label="$t('message.toBeAllocated') + `(${fbaTotal.status_wait_dispatch})`"
              name="status_wait_dispatch"></el-tab-pane>
            <!-- 待贴标 -->
            <el-tab-pane :label="$t('message.toBeLabeled') + `(${fbaTotal.status_wait_fba})`"
              name="status_wait_fba"></el-tab-pane>
            <!-- 贴标中 -->
            <el-tab-pane :label="$t('message.labelin') + `(${fbaTotal.status_in_fba})`"
              name="status_in_fba"></el-tab-pane>
            <!-- 待报价 -->
            <el-tab-pane :label="$t('message.toQuote') + `(${fbaTotal.status_wait_offer})`"
              name="status_wait_offer"></el-tab-pane>
            <!-- 待入金 -->
            <el-tab-pane :label="$t('message.pendingDeposit') + `(${fbaTotal.status_wait_client_pay})`"
              name="status_wait_client_pay"></el-tab-pane>
            <!-- 入金后配送单 -->
            <el-tab-pane :label="$t('message.deliveryReceiptAfterReceiptOfCash')"
              name="status_after_client_pay"></el-tab-pane>
            <!-- 待封箱 -->
            <el-tab-pane :label="$t('message.porderWaitSeal') + `(${fbaTotal.status_wait_seal})`"
              name="status_wait_seal"></el-tab-pane>
            <!-- 封箱完成 -->
            <el-tab-pane :label="$t('message.porderSealed') + `(${fbaTotal.status_sealed})`"
              name="status_sealed"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="operationContainer">
          <div class="leftContainer">
            <!-- 提出开始日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.proposeStartTime')" class="Container"
                type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
              </el-date-picker>
            </div>
            <!--   提出结束日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.proposeEndTime')" class="Container"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
              </el-date-picker>
            </div>
            <!-- 	翻译时间开始-->
            <div class="item">
              <el-date-picker v-model="datas.translate_at_start" :placeholder="$t('message.translationTimeStart')"
                class="Container" type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 180px">
              </el-date-picker>
            </div>
            <!-- 	翻译时间结束-->
            <div class="item">
              <el-date-picker v-model="datas.translate_at_end" :placeholder="$t('message.translationTimeEnd')"
                class="Container" default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 180px">
              </el-date-picker>
            </div>
            <!-- 请输入ID-->
            <div class="item">
              <el-input v-model="datas.user_id" :placeholder="$t('message.pleaseEnterID')" class="Container"
                onfocus="this.select()" />
            </div>
            <!--   请输入配送单号-->
            <div class="item">
              <el-input v-model="datas.porder_sn" :placeholder="$t('message.pleaseEnterTheShippingNumber')"
                class="Container" onfocus="this.select()" />
            </div>
            <!--   请输入订单号-->
            <div class="item">
              <el-input v-model="datas.order_sn" :placeholder="$t('message.pleaseEnterTheOrderNumber')"
                class="Container" onfocus="this.select()" />
            </div>

          </div>
        </div>
        <div class="operationContainer">
          <div class="leftContainer">
            <!--人员范围-->
            <div class="item">
              <!--  人员范围-->
              <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
            </div>
            <!--  全部人员-->
            <div class="item">
              <el-select v-model="datas.admin_id" :placeholder="$t('message.allPersonnel')" filterable clearable>
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 是否紧急 -->
            <div class="item"
              v-if="datas.fba_status_filter == 'status_wait_fba' || datas.fba_status_filter == 'status_in_fba'">
              <el-select v-model="datas.overdue" :placeholder="$t('message.isOverdue')" filterable clearable
                @change="$forceUpdate()">
                <el-option :label="$t('message.all')" value="0">
                </el-option>
                <el-option :label="$t('message.overdue')" value="1">
                </el-option>
              </el-select>
            </div>
            <div class="item">
              <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
                <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 业务 -->
            <div class="item">
              <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货员 -->
            <div class="item">
              <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
                <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- FBA -->
            <div class="item">
              <el-select v-model="datas.fba_user" clearable filterable placeholder="FBA">
                <el-option v-for="item in FBAlist" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="item">
              <!--  搜索 -->
              <el-button type="primary" @click="search">{{
                $t("message.search")
              }}</el-button>
              <!--  重置 -->
              <el-button @click="reset">{{ $t("message.reset") }}</el-button>
            </div>
          </div>

        </div>
        <div class="operationContainer">
          <div class="leftContainer">

          </div>
          <div class="rightContainer sealing-actions">
            <!-- 自定义表头 -->
            <el-button type="primary" @click="openColumnSettings">{{ $t('message.customColumns') }}</el-button>
            <!-- 订单展开或者收起 -->
            <el-button type="success" @click="isMaxHeight = !isMaxHeight">{{ isMaxHeight ? $t('message.orderExpand') :
              $t('message.orderCollapse') }}</el-button>
            <!-- FBA操作状况 -->
            <el-button type="primary" @click="$refs.fBAOperationWorkloadStatus.dialogVisible = true">{{
              $t("message.fBAOperationStatus")
            }}</el-button>
            <!--  分配FBA操作-->
            <el-button type="primary" class="primary" @click="assignFBAOperations" v-if="isAuth(258)">{{
              $t("message.assignFBAOperations")
            }}</el-button>
            <!-- 调整封箱员与封箱完成分别使用权限 779、780。 -->
            <el-button type="success" @click="openAssignSealer" v-if="isAuth(779)" :disabled="sealingCompleting">
              {{ $t('message.adjustPorderSealer') }}
            </el-button>
            <el-button type="primary" @click="completeSealing(checkedList)" v-if="isAuth(780)"
              :loading="sealingCompleting">
              {{ $t('message.batchSealPorders') }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="tableList">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName" ref="multipleTable" @cell-click="labelSelection" size="mini"
          :height="tableautoheight">
          <!-- 序号 -->
          <el-table-column align="center" :label="$t('message.serialNumber')" prop="rowNumber" width="60">
          </el-table-column>
          <el-table-column width="45" align="center">
            <template slot="header" slot-scope="scope">
              <el-checkbox v-model="checked" @change="allChangeItem" slot="reference"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-popover placement="right" title="合计" width="200" trigger="focus">
                <statistics :checkedList="checkedList" />
                <el-checkbox v-model="scope.row.checked" @change="changeItem" slot="reference"></el-checkbox>
              </el-popover>
            </template>
          </el-table-column>
          <!--  配送提出时间-->
          <el-table-column v-if="isColumnVisible('createdAt')" align="center"
            :label="$t('message.deliveryTimeOfPresentation')" prop="created_at" width="76">
          </el-table-column>
          <!--    FBA翻译时间 -->
          <el-table-column v-if="isColumnVisible('translateAt')" align="center" :label="$t('message.fBATranslationTime')"
            prop="porder_time_node.datetime_translate" width="76">
          </el-table-column>
          <!--    贴标时长（h） -->
          <el-table-column v-if="isColumnVisible('labelingTime')" align="center" :label="$t('message.labelingTime')"
            width="100">
            <template slot-scope="scope">
              <p>{{ scope.row.fba_duration }}</p>
              <!-- 具体时间点 -->
              <p>
                <el-popover placement="right" width="560" trigger="click">
                  <el-table :data="[scope.row.porder_time_node]" width="560px" size="small">
                    <!-- 给标时间 -->
                    <el-table-column :label="$t('message.markingTime')" prop="datetime_translate" align="center"
                      width="140"></el-table-column>
                    <!--开始贴标时间  -->
                    <el-table-column :label="$t('message.timeToStartLabeling')" prop="datetime_start_fba" align="center"
                      width="140"></el-table-column>
                    <!-- 完成贴标时间 -->
                    <el-table-column :label="$t('message.finishLabelingTime')" prop="datetime_confirm" align="center"
                      width="140"></el-table-column>
                    <!-- 发送时间 -->
                    <el-table-column :label="$t('message.sendingTime')" prop="datetime_delivery" align="center"
                      width="140"></el-table-column>
                  </el-table>
                  <el-button type="danger" size="mini" slot="reference">
                    {{ $t('message.specificTimePoint')
                    }}</el-button>
                </el-popover>

              </p>
            </template>
          </el-table-column>
          <!-- 订单属性 -->
          <el-table-column v-if="isColumnVisible('orderAttribute')" align="center"
            :label="$t('message.theOrderAttribute')" width="80">
            <template slot-scope="scope">
              <attributeName :name="scope.row.porder_attribute" />
            </template>
          </el-table-column>
          <!--  配送单号-->
          <el-table-column v-if="isColumnVisible('porderSn')" align="center" :label="$t('message.deliveryNoteNumber')">
            <template slot-scope="scope">
              <div class="template">
                <p>{{ scope.row.user.realname }}</p>
                <p>
                  <router-link :to="'/porderDetail?porder_sn=' + scope.row.porder_sn" target="_blank"
                    :style="{ color: scope.row.p_porder ? '#606266' : '' }">
                    {{ scope.row.porder_sn }}</router-link>
                </p>
                <span v-if="scope.row.is_fba == 1" class="is_fba">贴标</span>
                <span v-else>普通配送单</span>
                <p v-for="(item, index) in scope.row.porder_fba_type" :key="index"
                  style="color:#b4272d;font-size: 16px;">
                  {{ item.type }}
                </p>
                <!-- 亚马逊标识 -->
                <img src="@/assets/img/Amazon.png" alt="" style="width: 80px;" v-if="scope.row.is_amazon">
                <div v-if="scope.row.p_porder">
                  <p>
                    <router-link :to="'/porderDetail?porder_sn=' +
                      scope.row.p_porder_sn
                      " target="_blank">
                      父:{{ scope.row.p_porder_sn }}</router-link>
                  </p>
                </div>
                <div v-if="scope.row.sub_porder">
                  <p v-for="(item, index) in scope.row.sub_porder" :key="index">
                    <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank"
                      style="color: #606266;">
                      子:{{ item.porder_sn }}</router-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <!--  订单号-->
          <el-table-column v-if="isColumnVisible('orderSn')" align="center" :label="$t('message.orderNumber')">
            <template slot-scope="scope">
              <div class="orderList" :style="{ maxHeight: isMaxHeight ? '200px' : '10000px' }">
                <p v-for="(item, index) in scope.row.porder_detail" :key="index">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank">
                    {{ item.order_sn }}</router-link>
                </p>
              </div>
            </template>
          </el-table-column>
          <!--  发送数-->
          <el-table-column v-if="isColumnVisible('submitNum')" align="center"
            :label="$t('message.numberOfTransmissions')" width="80" prop="submit_num">
          </el-table-column>
          <!--  标签数-->
          <el-table-column v-if="isColumnVisible('tagNum')" align="center" :label="$t('message.numberOfTags')"
            width="80" prop="tag_num">
          </el-table-column>
          <!--  已打印数-->
          <el-table-column v-if="isColumnVisible('printedNum')" align="center"
            :label="$t('message.numberOfCopiesPrinted')" width="80" prop="tag_num_print">
          </el-table-column>
          <!--  实际贴标数-->
          <el-table-column v-if="isColumnVisible('actualTagNum')" align="center"
            :label="$t('message.actualNumberOfTags')" width="80" prop="fba_complete_num">
          </el-table-column>
          <!--  配送单状态-->
          <el-table-column v-if="isColumnVisible('porderStatus')" align="center" :label="$t('message.porderStatus')"
            width="80" prop="statusName">
            <template slot-scope="scope">
              <p>{{ scope.row.statusName }}</p>
              <p v-if="scope.row.created_by_admin == null">
                <el-tooltip class="item" effect="dark" :content="scope.row.user.realname" placement="right">
                  <div class="name">
                    客户
                  </div>
                </el-tooltip>
              </p>
              <p v-else>
                <el-tooltip class="item" effect="dark" :content="scope.row.created_by_admin.realname" placement="right">
                  <div class="name">
                    业务
                  </div>
                </el-tooltip>
              </p>
            </template>
          </el-table-column>
          <!--  操作人员-->
          <el-table-column v-if="isColumnVisible('operators')" align="center" :label="$t('message.operatingPersonne')"
            width="120">
            <template slot-scope="scope">
              <div class="text-left">
                <!-- 业务 -->
                <p>
                  {{ $t("message.business") }}：{{ scope.row.y_admin != null ? scope.row.y_admin.realname : '' }}
                </p>
                <!-- 配货 -->
                <p>
                  {{ $t("message.distribution") }}：{{
                    scope.row.p_admin != null ? scope.row.p_admin.realname : ''
                  }}
                </p>
                <!-- 采购 -->
                <p>{{ $t("message.purchase") }}：{{ scope.row.g_admin != null ? scope.row.g_admin.realname : '' }}</p>
                <!-- FBA -->
                <p>FBA：{{ scope.row.fba_admin != null ? scope.row.fba_admin.realname : '' }}</p>
                <!-- 封箱员 -->
                <p>{{ $t('message.porderSealer') }}：{{ scope.row.sealer_admin != null ? scope.row.sealer_admin.realname : '' }}</p>
              </div>
            </template>
          </el-table-column>
          <!--  贴标填写数-->
          <el-table-column v-if="isColumnVisible('labelEntryNum')" align="center"
            :label="$t('message.numberOfLabelEntries')" prop="fba_fill_num">
          </el-table-column>
          <!--  客户备注-->
          <!-- <el-table-column align="center" :label="$t('message.customerDeliveryNotes')"
            prop="porder_remark.client_remark">
          </el-table-column> -->
          <!--  业务配送单备注-->
          <el-table-column v-if="isColumnVisible('businessRemark')" align="center"
            :label="$t('message.businessPorderRemark')" width="200">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.porder_remark.y_remark" @blur="updateRemark(scope.row)"
                :disabled="remarkData.remark_type != 1"></el-input>
            </template>
          </el-table-column>
          <!--  配送单备注-->
          <el-table-column v-if="isColumnVisible('porderRemark')" align="center" :label="$t('message.porderRemark')"
            width="100" prop="porder_detail_count">
            <template slot-scope="scope">
              <!-- 具体时间点 -->
              <p>
                <el-popover placement="right" width="400" trigger="click">
                  <el-table :data="scope.row.remark" size="small">
                    <!-- 业务备注 -->
                    <el-table-column :label="$t('message.serviceRemarks')" prop="y_remark"></el-table-column>
                    <!--采购备注  -->
                    <el-table-column :label="$t('message.purchasingNotes')" prop="g_remark"></el-table-column>
                    <!-- 配货备注 -->
                    <el-table-column :label="$t('message.distributionRemarks')" prop="p_remark"></el-table-column>
                    <!-- FBA操作备注 -->
                    <el-table-column :label="$t('message.fBAOperationRemarks')" prop="fba_remark"></el-table-column>
                  </el-table>
                  <!-- 查看备注 -->
                  <el-button type="danger" size="mini" slot="reference"> {{ $t('message.viewRemarks')
                  }}</el-button>
                </el-popover>
              </p>
            </template>
          </el-table-column>
          <!--  业务贴标数修改备注-->
          <!-- <el-table-column align="center" :label="$t('message.numberOfServiceLabelsModifiedRemarks')"
            prop="porder_remark.p_remark">
          </el-table-column> -->
          <!-- 操作列固定在右侧，不参与自定义表头；封箱完成页签不再显示封箱入口。 -->
          <el-table-column align="center" :label="$t('message.operation')" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="isAuth(780) && datas.fba_status_filter != 'status_sealed'" type="text"
                :disabled="sealingCompleting" @click="completeSealing([scope.row])">
                {{ $t('message.sealPorder') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <columnSettingsDialog :visible.sync="columnSettingsVisible" :columns="columnOptions" :value="visibleColumns"
        @save="saveColumnSettings" />
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[50, 80, 100, 200]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 分配fba人员 -->
      <allocationFBA ref="allocationFBA" :porder_sn="porder_sn" :FBAlist="FBAlist" />
      <assignSealerDialog ref="assignSealerDialog" :candidates="sealerCandidates" :loading="sealerCandidatesLoading"
        :can-assign="isAuth(779)" @saved="refreshSealingList" />
      <!-- FBA操作工作量状况 -->
      <fBAOperationWorkloadStatus ref="fBAOperationWorkloadStatus" />
    </div>
  </div>
</template>

<script>
import allocationFBA from './components/allocationFBA'
import assignSealerDialog from './components/assignSealerDialog'
import fBAOperationWorkloadStatus from './components/fBAOperationWorkloadStatus'
import statistics from './components/statistics'
import columnSettingsDialog from '@/views/porderDetail/components/columnSettingsDialog'

// 可自定义显示的表格列；序号和勾选框固定显示，不放入配置。
const columnOptions = [
  { key: 'createdAt', labelKey: 'message.deliveryTimeOfPresentation' },
  { key: 'translateAt', labelKey: 'message.fBATranslationTime' },
  { key: 'labelingTime', labelKey: 'message.labelingTime' },
  { key: 'orderAttribute', labelKey: 'message.theOrderAttribute' },
  { key: 'porderSn', labelKey: 'message.deliveryNoteNumber' },
  { key: 'orderSn', labelKey: 'message.orderNumber' },
  { key: 'submitNum', labelKey: 'message.numberOfTransmissions' },
  { key: 'tagNum', labelKey: 'message.numberOfTags' },
  { key: 'printedNum', labelKey: 'message.numberOfCopiesPrinted' },
  { key: 'actualTagNum', labelKey: 'message.actualNumberOfTags' },
  { key: 'porderStatus', labelKey: 'message.porderStatus' },
  { key: 'operators', labelKey: 'message.operatingPersonne' },
  { key: 'labelEntryNum', labelKey: 'message.numberOfLabelEntries' },
  { key: 'businessRemark', labelKey: 'message.businessPorderRemark' },
  { key: 'porderRemark', labelKey: 'message.porderRemark' },
]
const defaultColumns = columnOptions.map(item => item.key)

export default {
  components: {
    allocationFBA,
    assignSealerDialog,
    fBAOperationWorkloadStatus,
    statistics,
    columnSettingsDialog,
  },
  data() {
    return {
      isMaxHeight: true,
      columnOptions,
      visibleColumns: [...defaultColumns],
      columnSettingsVisible: false,
      datas: {
        // 检品工种进入 FBA 贴标列表时默认查看待贴标
        fba_status_filter: localStorage.getItem("japanUserRoleStatus") == 6 ? "status_wait_fba" : "",
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        translate_at_start: "",
        translate_at_end: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
      },
      fbaTotal: {
        status_wait_dispatch: 0,
        status_wait_fba: 0,
        status_in_fba: 0,
        status_wait_offer: 0,
        status_wait_client_pay: 0,
        status_after_client_pay: 0,
        status_wait_seal: 0,
        status_sealed: 0,
      },
      total: 0,
      tableData: [],
      userList: [],
      porder_sn: [],//选中的配送单
      FBAlist: [],// fba列表
      sealerCandidates: [],
      sealerCandidatesLoading: false,
      sealerCandidatesLoaded: false,
      sealingCompleting: false,
      remarkData: {
        porder_sn: "",
        remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
        col: "y_remark",
        value: "",
      },
      checkedList: [],
      checked: false,
    };
  },
  computed: {
    tableautoheight() {
      return window.innerHeight > 500 ? window.innerHeight - 120 : 800
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.loadColumnSettings()
    let query = this.$route.query
    if (query.status) {
      this.datas.fba_status_filter = query.status
    }
    if (query.overdue) {
      this.datas.overdue = query.overdue
    }
    this.fbaListTotal()
    this.fbaList()
    this.fbaUserList()
    this.loadSealerCandidates()
  },
  methods: {
    openAssignSealer() {
      if (!this.isAuth(779) || this.sealingCompleting) return
      const porderSns = this.getSealingPorderSns(this.checkedList)
      if (!porderSns.length) return
      this.loadSealerCandidates()
      this.$refs.assignSealerDialog.open(porderSns)
    },
    // 单条和批量共用接口，锁定确认过程，用户确认后才发起请求。
    async completeSealing(list) {
      if (!this.isAuth(780) || this.sealingCompleting) return
      const porderSns = this.getSealingPorderSns(list)
      if (!porderSns.length) return
      this.sealingCompleting = true
      try {
        await this.$confirm(this.$t('message.confirmSealingComplete'), this.$t('message.prompt'), {
          confirmButtonText: this.$t('message.confirm'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning',
          center: true,
        })
        if (!this.isAuth(780)) return
        const res = await this.$api.porderApi.sealingComplete({ porder_sn: porderSns })
        if (res.code != 0 || res.success === false) return
        this.$message.success(res.msg)
        this.refreshSealingList()
      } catch (error) {
        // 取消确认不提交；接口失败由公共请求层提示。
      } finally {
        this.sealingCompleting = false
      }
    },
    // 筛选与调整弹窗共用一份候选人员，加载成功后不再重复请求。
    loadSealerCandidates() {
      if (this.sealerCandidatesLoading || this.sealerCandidatesLoaded) return
      this.sealerCandidatesLoading = true
      this.$api.porderApi.sealingCandidates().then((res) => {
        if (res.code != 0 || res.success === false) return
        this.sealerCandidates = res.data
        this.sealerCandidatesLoaded = true
      }).catch(() => {
        // 失败提示由公共请求层处理，下一次打开调整弹窗时可重新加载。
      }).finally(() => {
        this.sealerCandidatesLoading = false
      })
    },
    // 调整和封箱接口都限制为去重后的 1 至 200 个非空配送单号。
    getSealingPorderSns(list) {
      const porderSns = [...new Set(list.map(item => item.porder_sn))]
      if (!porderSns.length || porderSns.length > 200 || porderSns.some(sn => typeof sn !== 'string' || !sn.trim())) {
        this.$message.error(this.$t('message.sealingPorderLimit'))
        return []
      }
      return porderSns
    },
    // 操作成功后同时更新列表与全部页签数量，并清空旧的勾选项。
    refreshSealingList() {
      this.checked = false
      this.checkedList = []
      this.fbaList()
      this.fbaListTotal()
    },
    // 按账号隔离配置，避免同一浏览器切换账号时互相覆盖。
    getColumnStorageKey() {
      let userId = 'default'
      try {
        const userInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo') || '{}')
        userId = userInfo.id || 'default'
      } catch (error) {
        userId = 'default'
      }
      return `porderLabeling:columnConfig:v1:${userId}`
    },
    // 本地配置不存在或损坏时保持默认全部显示；以后新增的列也会自动显示。
    loadColumnSettings() {
      try {
        const savedConfig = JSON.parse(localStorage.getItem(this.getColumnStorageKey()) || '{}')
        if (savedConfig.columns) {
          this.visibleColumns = defaultColumns.filter(key => savedConfig.columns[key] !== false)
        }
      } catch (error) {
        // 本地配置损坏时使用默认展示方案
      }
    },
    isColumnVisible(key) {
      return this.visibleColumns.includes(key)
    },
    openColumnSettings() {
      this.columnSettingsVisible = true
    },
    saveColumnSettings(selectedColumns) {
      this.visibleColumns = selectedColumns
      // 保存显隐状态而不是表头文字，切换语言后配置仍然有效。
      const columns = defaultColumns.reduce((result, key) => {
        result[key] = this.visibleColumns.includes(key)
        return result
      }, {})
      localStorage.setItem(this.getColumnStorageKey(), JSON.stringify({
        version: 1,
        columns,
      }))
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
    //FBA人员列表
    fbaUserList() {
      this.$api.porderApi.fbaUserList().then(res => {
        this.FBAlist = res.data
      })
    },
    // 页签数量独立统计，不传 fba_status_filter，避免受当前所选状态限制。
    fbaListTotal() {
      this.$api.porderApi.fbaListTotal().then(res => {
        this.fbaTotal = res.data
      })
    },
    // 标记颜色
    tableRowClassName({ row, rowIndex }) {
      const isMoreThan3Days = (date) => {
        const diff = Math.abs(new Date() - new Date(date));
        return diff > 259200000; // 3天的毫秒数
      };
      if ((this.datas.fba_status_filter == 'status_wait_fba' || this.datas.fba_status_filter == 'status_in_fba') && isMoreThan3Days(row.porder_time_node.datetime_translate)) {
        return 'Danger';
      }
      // console.log(row);
      return '';
    },
    // 列表
    fbaList() {
      this.$api.porderApi.fbaList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
          item.porder_remark == null ? item.porder_remark = {} : item.porder_remark
          item.FBATime = [
            item.porder_time_node
          ]
          item.remarkList = [
            item.porder_remark
          ]
        })
        this.tableData = res.data.data
        this.tableData.forEach((list) => {
          // 数组去重
          var hash = {};
          list.porder_detail = list.porder_detail.reduce(function (item, next) {
            hash[next.order_sn]
              ? ""
              : (hash[next.order_sn] = true && item.push(next));
            return item;
          }, []);
          list.porder_fba_type = list.porder_fba_type.reduce(function (item, next) {
            hash[next.type]
              ? ""
              : (hash[next.type] = true && item.push(next));
            return item;
          }, []);
        });
        this.total = res.data.total
        this.selectList = []
        this.checkedList = []
        this.checked = false
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.datas.FBA_id = ''
      this.fbaList();
    },
    // 重置
    reset() {
      this.datas = {
        fba_status_filter: "",
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
        y_id: '',
        g_id: '',
        p_id: '',
        fba_user: '',
        translate_at_start: '',
        translate_at_end: '',
      };
      this.$refs.cascader.orgId = [];
      this.fbaList();
    },
    // 全选
    allChangeItem() {
      this.checkedList = []
      this.tableData.forEach(item => {
        item.checked = this.checked
        if (item.checked) {
          this.checkedList.push(item)
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.fbaList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.fbaList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 分配FBA操作
    assignFBAOperations() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.porder_sn = []
      this.checkedList.forEach(item => {
        this.porder_sn.push(item.porder_sn)
      })
      this.$refs.allocationFBA.dialogVisible = true
    },
    // 备注
    updateRemark(item) {
      this.remarkData.porder_sn = item.porder_sn
      this.remarkData.value = item.porder_remark.y_remark
      this.$api.porderApi.updateRemark(this.remarkData).then((res) => {
        if (res.code != 0) return this.$message.error(res.message);
      });
    },
    // 单选
    changeItem() {
      this.checkedList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.checkedList.push(item)
        }
      })
    },
  }
}
</script>

<style lang='scss' scoped>
.search {



  /deep/.el-input__inner {
    width: 217px;
  }
}

/deep/ .el-textarea__inner {
  padding: 3px;
  min-height: 100px !important;
  font-size: 13px;
}

.tableList {
  margin: 20px 0;

  /deep/.el-button {
    width: 92px;
  }

  .name {
    font-size: 20px;
    color: #b4272d;
    width: 100%;
  }
}

.table {
  ul {
    border: 1px solid #edeff4;
    border-top: 0;
    padding: 0;

    &:nth-child(1) {
      border-top: 1px solid #edeff4;
    }

    li {
      border-right: 1px solid #edeff4;
      padding: 10px 0;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex2 {
      flex: 2;
    }
  }


}

.item {
  margin-right: 20px;
}

.operationContainer {
  display: flex;
  margin-bottom: 20px;

  /deep/.el-input__inner {
    width: 200px;
  }

  .el-date-editor {
    width: 200px;
    margin-right: 20px;
  }

  .leftContainer {
    flex: 7;
  }

  .rightContainer {
    flex: 1;

    &.sealing-actions {
      display: flex;
      flex: none;
      width: auto;
      flex-wrap: nowrap;
      justify-content: flex-end;
      gap: 10px;
      max-width: 100%;

      .el-button {
        flex-shrink: 0;
        margin-left: 0;
      }
    }
  }
}

/deep/.cell {
  padding: 3px 3px !important;
}

.content {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }

  /deep/.el-radio {
    margin-bottom: 20px;
  }
}

.orderList {
  overflow-y: auto;
}

.template {
  text-align: left;
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

.is_fba {
  font-size: 20px;
  color: #67C23A;
  font-weight: bold;
}

/deep/.Danger {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

/deep/.el-table tbody .Danger:hover>td {
  background-color: rgba(242, 210, 235, 0.5) !important;
}
</style>
